import { ReactElement } from 'react';
import { StyledRow, EmptyCell } from './styles';
import Row from './Row';
import { useApplications } from '../hooks/useApplications';
import { formatDate } from '../utils/dateFormatter';
import { composeName } from '../utils/composeName';
import type { Honbu } from '../types';

interface Props {
  honbu: Honbu;
}

const Rows = ({ honbu }: Props): ReactElement => {
  const applications = useApplications(honbu);

  if (applications.length === 0) {
    return (
      <StyledRow>
        <EmptyCell>履歴データがありません</EmptyCell>
      </StyledRow>
    );
  }

  const rows = applications.map(application => ({
    id: application.id,
    rpmApplicantId: application.rpmApplicantId ?? '-',
    fullName: composeName(application.sei, application.mei),
    fullNameKana: composeName(application.seiKana, application.meiKana),
    phone: application.phoneNumber ?? application.mobileNumber ?? '-',
    applicantStatus: application.applicantStatus ?? '-',
    callResultStatus: application.callResultStatus,
    formattedDate: formatDate(application.calledAt),
  }));

  return (
    <>
      {rows.map(row => (
        <Row
          key={row.id}
          id={row.id}
          rpmApplicantId={row.rpmApplicantId}
          fullName={row.fullName}
          fullNameKana={row.fullNameKana}
          phone={row.phone}
          applicantStatus={row.applicantStatus}
          callResultStatus={row.callResultStatus}
          formattedDate={row.formattedDate}
        />
      ))}
    </>
  );
};

export default Rows;
